document.addEventListener('DOMContentLoaded', () => {
  const articleContent = document.querySelector('.rte, .article-content, .blog-post-content');

  if (!articleContent) return;

  const faqHeading = [...articleContent.querySelectorAll('h2')]
    .find(h => h.textContent.trim().toLowerCase() === 'frequently asked questions');

  if (!faqHeading) return;

  const accordion = document.createElement('div');
  accordion.className = 'blog-faq-accordion';

  let current = faqHeading.nextElementSibling;

  while (current) {
    if (current.tagName === 'H2') break;

    if (current.tagName === 'H3') {
      const question = current.textContent.trim();
      const answerNode = current.nextElementSibling;

      if (answerNode && answerNode.tagName === 'P') {
        const item = document.createElement('div');
        item.className = 'blog-faq-item';

        item.innerHTML = `
          <button class="blog-faq-question" aria-expanded="false">
            ${question}
          </button>
          <div class="blog-faq-answer">
            ${answerNode.outerHTML}
          </div>
        `;

        accordion.appendChild(item);

        current.style.display = 'none';
        answerNode.style.display = 'none';
      }
    }

    current = current.nextElementSibling;
  }

  faqHeading.insertAdjacentElement('afterend', accordion);

  const faqItems = accordion.querySelectorAll('.blog-faq-item');

  // Open first FAQ by default
  if (faqItems.length > 0) {
    const firstItem = faqItems[0];
    const firstButton = firstItem.querySelector('.blog-faq-question');
    const firstAnswer = firstItem.querySelector('.blog-faq-answer');

    firstItem.classList.add('active');
    firstButton.setAttribute('aria-expanded', 'true');
    firstAnswer.style.maxHeight = firstAnswer.scrollHeight + 'px';
  }

  faqItems.forEach(item => {
    const button = item.querySelector('.blog-faq-question');
    const answer = item.querySelector('.blog-faq-answer');

    button.addEventListener('click', () => {
      const isActive = item.classList.contains('active');

      // Close all FAQs
      faqItems.forEach(otherItem => {
        const otherButton = otherItem.querySelector('.blog-faq-question');
        const otherAnswer = otherItem.querySelector('.blog-faq-answer');

        otherItem.classList.remove('active');
        otherButton.setAttribute('aria-expanded', 'false');
        otherAnswer.style.maxHeight = null;
      });

      // Open clicked FAQ if it wasn't already open
      if (!isActive) {
        item.classList.add('active');
        button.setAttribute('aria-expanded', 'true');
        answer.style.maxHeight = answer.scrollHeight + 'px';
      }
    });
  });

  // Recalculate heights on resize
  window.addEventListener('resize', () => {
    const activeItem = accordion.querySelector('.blog-faq-item.active');

    if (activeItem) {
      const activeAnswer = activeItem.querySelector('.blog-faq-answer');
      activeAnswer.style.maxHeight = activeAnswer.scrollHeight + 'px';
    }
  });
});